// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__G1_sD","label":"styles_label__hSA0M","span":"styles_span__Q2Ely","input":"styles_input__CMxmE"};